import { useEffect, useState } from 'react';
import './style.css';
import { useTranslation } from 'react-i18next';

const InputArea = ({
  value,
  icon,
  placeholder,
  style,
  onChange,
  disabled,
  onBlur,
  maxLength,
  rows = 4,
}) => {
  const { t } = useTranslation();

  const [disallowedNames, setDisallowedNames] = useState([
    t('new_category'),
    t('new_property'),
    t('new_plant'),
    t('new_area'),
    t('new_sub_area'),
    t('new_line'),
    t('new_machine'),
    t('new_assembly'),
    t('new_equipment'),
    t('new_component'),
    t('new_instrument'),
    t('new_system'),
    t('new_cost_center'),
    t('new_manufacturer'),
    t('new_organization'),
    t('new_department'),
    t('new_interconnection'),
    t('new_user'),
    t('new_user_group'),
    t('new_executor'),
  ]);

  useEffect(() => {
    setDisallowedNames([
      t('new_category'),
      t('new_property'),
      t('new_plant'),
      t('new_area'),
      t('new_sub_area'),
      t('new_line'),
      t('new_machine'),
      t('new_assembly'),
      t('new_equipment'),
      t('new_component'),
      t('new_instrument'),
      t('new_system'),
      t('new_cost_center'),
      t('new_manufacturer'),
      t('new_organization'),
      t('new_department'),
      t('new_interconnection'),
      t('new_user'),
      t('new_user_group'),
      t('new_executor'),
    ]);
  }, [t]);

  return (
    <div className='inputAreaContainer'>
      {icon && <div className='inputAreaIconContainer'>{icon}</div>}
      <textarea
        disabled={disabled}
        value={
          disallowedNames.some(
            (name) =>
              name.toLocaleLowerCase().replace(/ /g, '') ===
              `${value}`?.toLocaleLowerCase().replace(/ /g, ''),
          )
            ? ''
            : value
        }
        placeholder={placeholder}
        style={{ ...style, paddingLeft: icon ? '3rem' : '' }}
        className={`customInputArea ${disabled ? 'disabled' : ''}`}
        onChange={(e) => {
          onChange(e);
        }}
        maxLength={maxLength}
        onBlur={onBlur ? onBlur : () => {}}
        rows={rows}
      />
    </div>
  );
};

export default InputArea;
